import { useMemo, useState } from 'react'
import './Avatar.scss'

const normalizeText = value => {
  if (value == null) return ''
  const text = String(value).trim()
  if (!text) return ''
  const lower = text.toLowerCase()
  if (lower === 'undefined' || lower === 'null') return ''
  return text
}

const sanitizeName = name =>
  normalizeText(name).split(/\s+/).filter(Boolean).join(' ')

const sanitizeSrc = src => {
  const clean = normalizeText(src)
  if (!clean) return ''
  if (clean.toLowerCase() === 'undefined' || clean.toLowerCase() === 'null') {
    return ''
  }
  return clean
}

const getInitials = (name = '') => {
  const parts = sanitizeName(name).split(' ').filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  return (parts[0]?.[0] || '?').toUpperCase()
}

const stringToColor = (str = '') => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  const colors = [
    '#2440ab',
    '#3b82f6',
    '#2563eb',
    '#0ea5e9',
    '#06b6d4',
    '#14b8a6',
    '#10b981',
    '#22c55e',
    '#84cc16',
    '#eab308',
    '#f59e0b',
    '#f97316',
    '#ef4444',
    '#ec4899',
    '#d946ef',
    '#a855f7',
    '#8b5cf6',
    '#6366f1',
    '#64748b',
    '#0f766e',
    '#166534',
    '#7c2d12',
    '#991b1b',
    '#7e22ce',
    '#1d4ed8',
  ]
  return colors[Math.abs(hash) % colors.length]
}

export const Avatar = ({ name, src, size = 'md', className = '', bgColor }) => {
  const safeName = useMemo(() => sanitizeName(name), [name])
  const safeSrc = useMemo(() => sanitizeSrc(src), [src])
  const [imageError, setImageError] = useState(false)

  const initials = getInitials(safeName)
  const computedBg = bgColor || stringToColor(safeName || '?')
  const altText = safeName || 'Avatar'

  const classes = ['tb-avatar', `tb-avatar--${size}`, className]
    .filter(Boolean)
    .join(' ')

  if (safeSrc && !imageError) {
    return (
      <div className={classes}>
        <img
          src={safeSrc}
          alt={altText}
          className="tb-avatar__img"
          onError={() => setImageError(true)}
        />
      </div>
    )
  }

  return (
    <div className={classes} style={{ backgroundColor: computedBg }}>
      <span className="tb-avatar__initials">{initials}</span>
    </div>
  )
}
